/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeModel } from '../../models/employee-model';

export interface GetClientReps$Plain$Params {
  email?: string;
}

export function getClientReps$Plain(http: HttpClient, rootUrl: string, params?: GetClientReps$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeModel>>> {
  const rb = new RequestBuilder(rootUrl, getClientReps$Plain.PATH, 'get');
  if (params) {
    rb.query('email', params.email, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EmployeeModel>>;
    })
  );
}

getClientReps$Plain.PATH = '/api/ClientRep';
